import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { getDiscountPrice } from "../../helpers/product";
import ProductImageGallery from "../../components/product/ProductImageGallery";
import ProductDescriptionInfo from "../../components/product/ProductDescriptionInfo";
import styled from "styled-components";
import { device } from "../../utils/breakpoints";
import ProductInformationTab from "./ProductInformationTab";
import { useTranslation } from "react-i18next";
import useIsMobile from "../../components/hooks/useIsMobile";

const ProductImageDescription = ({
  spaceTopClass,
  spaceBottomClass,
  galleryType,
  product,
  cartItems,
  compareItems,
  isFeatured,
}) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const compareItem = compareItems.filter(
    (compareItem) => compareItem.id === product.id,
  )[0];
  const discountedPrice = getDiscountPrice(product.price, product.discount);

  return (
    <div className={"shop-area mb-1"}>
      <div className="container">
        <div className="row">
          <div className="col-lg-7 col-md-6">
            <ProductName className={!!product.shortDescription ? "" : "mb-2"}>
              {product.name}
            </ProductName>
            {!!product.shortDescription && (
              <ShortDescription>{product.shortDescription}</ShortDescription>
            )}
            <ProductImageGallery product={product} isFeatured={isFeatured} />
            {/* product description tab */}
            {!isMobile &&
              (!!product.additionalInfo ||
                !!product.description ||
                !!product.allergens) && (
                <ProductInformationTab
                  spaceBottomClass="pb-100"
                  additionalInfoTitle={t("additional_info")}
                  additionalInfo={product.additionalInfo}
                  description={product.description}
                  allergens={product.allergens}
                />
              )}
          </div>
          <div className="col-lg-5 col-md-6">
            {/* product description info */}
            <ProductDescriptionInfo
              product={product}
              discountedPrice={discountedPrice}
              cartItems={cartItems}
              compareItem={compareItem}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const ShortDescription = styled.h3`
  color: #333;
  font-weight: 400;
  font-size: 15px;
  line-height: 21px;
  display: block;
  margin-bottom: 6px;
`;

const ProductName = styled.h1`
  font-size: 1.25em;
  font-weight: 600;
  line-height: 1.25;
  color: #333;
  margin-bottom: 0;

  @media ${device.lg} {
    font-size: 1.75em;
  }
`;

ProductImageDescription.propTypes = {
  cartItems: PropTypes.array,
  compareItems: PropTypes.array,
  galleryType: PropTypes.string,
  product: PropTypes.object,
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    cartItems: state.cartData,
    compareItems: state.compareData,
  };
};

export default connect(mapStateToProps)(ProductImageDescription);
